import { createFileRoute } from '@tanstack/react-router';

import { ExerciseCatalogList } from '@/features/exercises/components/ExerciseCatalogList';
import { requirePermission } from '@/lib/guards';

export const Route = createFileRoute('/app/exercises/')({
  beforeLoad: () => {
    requirePermission('engagement:read');
  },
  component: ClinicalExercisesCatalogScreen,
  staticData: { crumb: 'Exercises' },
});

function ClinicalExercisesCatalogScreen() {
  return <ExerciseCatalogList surface="clinical" />;
}
